import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-8">
          <p className="text-base font-medium mb-2">高度な技術力を駆使して製造プロセスの開発、研究。</p>
          <p className="text-base font-medium">そして革新的な提案を行います</p>
        </div>
        
        <div className="border-t border-teal-500 pt-8">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4">
            <div className="text-sm text-center">
              <p className="mb-1">&copy; 2026 Mission Co.,Ltd.</p>
              <p className="text-xs opacity-90">株式会社ミション</p>
              <p className="text-xs opacity-90">〒559-0034 大阪府大阪市住之江区南港北１丁目29-1 大阪ベイレジデンス1405</p>
              <p className="text-xs opacity-90">TEL: 090-3677-1000</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
